<template>
  <div class="menu-wrap flex flex-col gap-1" style="border: 0">
    <div
      v-permission="'publish_manage_menu'"
      class="menu-content"
      :class="{
        'active-route': [
          'publishManage',
          'publishManageAgentAnalysis',
        ].includes(routeName),
      }"
      data-testid="publish-manage-menu-button"
      @click="handleNavigate('publishManage')"
    >
      <BotIcon name="send-plane-line" :padding="0" />
      <span class="menu-name">{{
        $t(
          'views.layout.components.OpsMenuList.b530be4a3f14d1f16225b40fa13e663f'
        )
      }}</span>
    </div>
    <div
      v-if="showVoiceTaskCenter"
      class="menu-content"
      :class="{
        'active-route': [
          'voiceTaskCenter',
          'voiceTaskCenterTaskDetail',
          'voiceTaskCenterCallDetail',
        ].includes(routeName),
      }"
      data-testid="voice-task-center-menu-button"
      @click="handleNavigate('voiceTaskCenter')"
    >
      <BotIcon name="line_phone" :padding="0" />
      <span class="menu-name">{{
        $t(
          'views.layout.components.OpsMenuList.1dc034341711e0551fbb51b6722faa47'
        )
      }}</span>
    </div>
    <div
      v-permission="'online_observation_menu'"
      class="menu-content"
      :class="{
        'active-route': [
          'agentOpsObservability',
          'observabilityDetail',
        ].includes(routeName),
      }"
      data-testid="observability-menu-button"
      @click="handleNavigate('observability')"
    >
      <BotIcon name="line-chart-line" :padding="0" />
      <span class="menu-name">{{
        $t(
          'views.layout.components.OpsMenuList.5e9b17990ee150f642f23c5bdc92aa27'
        )
      }}</span>
    </div>
    <div
      v-permission="'auto_optimization_menu'"
      class="menu-content"
      :class="{
        'active-route': routeName === 'agentOpsAutoTuning',
      }"
      data-testid="auto-tuning-menu-button"
      @click="handleNavigate('autoTuning')"
    >
      <BotIcon name="auto-line" :padding="0" />
      <span class="menu-name">{{
        $t(
          'views.layout.components.OpsMenuList.d834fd62ffd2e36b4dabbc19f0272d7c'
        )
      }}</span>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getVoiceTaskCenterWhitelistApi } from '@api/voiceTaskCenter';

export default defineComponent({
  name: 'OpsMenuList',
  props: {
    routeName: {
      type: String,
      default: '',
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const enableWhite = ref(false);
    const whiteList = ref([]);
    const whiteListLoaded = ref(false);

    // Domestic builds never call the white list, so the menu stays hidden there;
    // overseas builds show it only when the switch is on AND the account is on
    // the list.
    const showVoiceTaskCenter = computed(() => {
      if (IS_DOMESTIC) return false;
      if (!whiteListLoaded.value) return false;
      if (!enableWhite.value) return false;
      const { email, userName } = store.getters.botUserInfo || {};
      return (
        whiteList.value.includes(email) || whiteList.value.includes(userName)
      );
    });

    onMounted(async () => {
      // Only the overseas build calls the white-list endpoint; the domestic
      // build has no access to the voice task center.
      if (IS_DOMESTIC) {
        return;
      }
      try {
        const res = await getVoiceTaskCenterWhitelistApi();
        enableWhite.value = !!res?.enable_white;
        whiteList.value = Array.isArray(res?.white_list) ? res.white_list : [];
      } catch (error) {
        // The menu stays hidden when the whitelist cannot be read.
        console.warn('[voiceTaskCenter] whitelist request failed', error);
      } finally {
        whiteListLoaded.value = true;
      }
    });

    const handleNavigate = (route, permissionKey = null) => {
      if (permissionKey) {
        return;
      }
      router.push(`/${route}`);
    };
    return {
      handleNavigate,
      showVoiceTaskCenter,
    };
  },
});
</script>
<style scoped lang="less">
.menu-item {
  cursor: pointer;
}
.menu-name {
  margin-left: 8px;
  margin-right: 12px;
  color: var(--text-neutral-color-text-primary);
}

.menu-content {
  width: 100%;
  display: flex;
  align-items: center;
  height: 32px;
  margin-bottom: 2px;
  cursor: pointer;
  border-radius: 6px;
  padding: 0 16px;
  &:hover {
    background-color: var(--background-fill-white-color-fill-secondary);
  }
}
.menu-content-disabled {
  cursor: not-allowed;
  color: var(--false-color);
}
.active-route {
  background-color: var(--background-neutral-bg-color-container);
  font-weight: 600;
  color: var(--text-primary-color-primary-text);
  .menu-name {
    color: var(--text-primary-color-primary-text);
  }
  &:hover {
    background-color: var(--background-neutral-bg-color-elevated);
  }
}
</style>
